import React from "react";
import { useNavigate } from "react-router-dom";
import { Flex, Heading, useAuthenticator } from "@aws-amplify/ui-react";
import SwitchProfileViewTable from "./containers/SwitchProfileViewTable";
import { useUserQuery } from "../common/useUserQuery";
import { useUserMutation } from "../common/useUserMutation";
import SwitchProfileMinorsViewTable from "./containers/SwitchProfileMinorsViewTable";
import { useCareGiversByIdQuery } from "../careGivers/api/useCareGiversQuery";
import { useMinorDependentsQuery } from "../minorDependents/api/useMinorDependentsQuery";

export default function SwitchProfilePage() {
  const navigate = useNavigate();
  const { user } = useAuthenticator((context) => [context.user]);
  const { data: careGiversData, isFetching: isFetchingCareGiversData } =
    useCareGiversByIdQuery(user?.userId);
  const {
    data: minorDependentsData,
    isFetching: isFetchingMinorDependentsData,
  } = useMinorDependentsQuery(user?.userId);
  const { data: activeProfile } = useUserQuery();
  const { mutate: userMutate } = useUserMutation();

  // SETS GLOBAL PROFILE TO SELECTED USER
  const handleSwitchToProfileClick = (
    patientUserId,
    patientUserGivenName = "",
    patientUserNickname = ""
  ) => {
    const advocateSessionObject = {
      patientUserId: patientUserId,
      isAdvocating: true,
      givenName: patientUserGivenName,
      nickname: patientUserNickname,
    };
    sessionStorage.setItem(
      "advocateSession",
      JSON.stringify(advocateSessionObject)
    );
    userMutate(advocateSessionObject);
  };

  // RESETS GLOBAL PROFILE TO LOGGED IN USER
  const handleStopSessionClick = () => {
    sessionStorage.removeItem("advocateSession");
    userMutate({ patientUserId: user?.userId, isAdvocating: false });
  };

  return (
    <Flex
      direction="column"
      padding="32px 32px 32px 32px"
      backgroundColor="rgba(250,250,250,1)"
    >
      <Flex direction="row" alignItems="center">
        <Heading level="1" children="Switch Profile"></Heading>
      </Flex>
      <Flex direction="column">
        {isFetchingCareGiversData ? (
          <div>
            <span>Loading users I can caregive...</span>
          </div>
        ) : (
          <SwitchProfileViewTable
            activeProfile={activeProfile}
            careGiversData={careGiversData}
            onSwitchClick={handleSwitchToProfileClick}
            onStopSessionClick={handleStopSessionClick}
          />
        )}
        {isFetchingMinorDependentsData ? (
          <div>
            <span>Loading minor dependents...</span>
          </div>
        ) : (
          <SwitchProfileMinorsViewTable
            activeProfile={activeProfile}
            minorDependentsData={minorDependentsData}
            onSwitchClick={handleSwitchToProfileClick}
            onStopSessionClick={handleStopSessionClick}
          />
        )}
      </Flex>
    </Flex>
  );
}
